import EditUser from "../components/UserManagement/Edit/EditUser";

const EditUserPage = (props) => {
    return <EditUser userData={props.location} />
}

export default EditUserPage;